<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }

</script>

<style lang='less'>
  * {
    margin: 0;
    padding: 0;
    
  }

  body {
    min-width:  1479px;
    max-width: 1920px;
    margin: 0 auto;
    font-size: 0;
  }

  .gs_stage {
    width: 100%;
  }

  .gs_module {
    width: 1479px;
    margin: 0 auto;
    padding: 80px 0;
    font-size: 16px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .gs_introduce {
    width: 584px;
    text-align: right;
    color: #666;
    .gs_title {
      font-size: 32px;
      margin-bottom: 60px;
    }

    .gs_content {
      line-height: 30px;
      margin-bottom: 22px;
    }
  }

  .gs_contentImg {
    width: 848px;
    flex-shrink: 0;

    img {
      width: 100%;
    }
  }

  @media screen and (max-width: 750px) {
    body {
    min-width: auto;
    max-width: auto;
  }
    .gs_module {
      display: block;
      width: auto;
      padding: 30px 10px 21px;
      font-size: 12px;
    }

    .gs_introduce {
      width: auto;
      text-align: left !important;

      .gs_title {
        font-size: 16px;
        margin-bottom: 15px;
      }

      .gs_content {
        line-height: 20px;
        margin-bottom: 22px;
      }
    }

    .gs_contentImg {
      width: auto;

      img {
        width: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue